import { AppBar, Toolbar, Typography, Box, Button, Menu, MenuItem, Avatar, IconButton, useMediaQuery, useTheme } from "@mui/material";
import { useState } from "react";
import { Logout as LogoutIcon, Menu as MenuIcon } from "@mui/icons-material";

export default function Topbar({ onLogout, user, onMenuClick, isMobile }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const theme = useTheme();
  const isResponsiveMobile = useMediaQuery(theme.breakpoints.down("md"));

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    handleClose();
    onLogout();
  };

  const getInitials = (email) => {
    return email ? email.charAt(0).toUpperCase() : 'U';
  };

  return (
    <AppBar
      position="static"
      elevation={0}
      sx={{
        bgcolor: "#fff",
        color: "#333",
        borderBottom: "1px solid #e0e0e0"
      }}
    >
      <Toolbar
        sx={{
          display: "flex",
          justifyContent: "space-between",
          px: isResponsiveMobile ? 1 : 2
        }}
      >
        {/* Hamburger menu for mobile */}
        {isResponsiveMobile && (
          <IconButton
            color="inherit"
            aria-label="toggle menu"
            onClick={onMenuClick}
            sx={{ mr: 1 }}
          >
            <MenuIcon />
          </IconButton>
        )}

        <Typography
          variant={isResponsiveMobile ? "body1" : "h6"}
          sx={{ fontWeight: 600, flexGrow: isResponsiveMobile ? 1 : 0 }}
        >
          MissionTracker
        </Typography>

        <Box sx={{ display: "flex", alignItems: "center", gap: isResponsiveMobile ? 1 : 2 }}>
          {user && (
            <>
              {!isResponsiveMobile && (
                <Typography variant="body2" sx={{ color: "#666" }}>
                  {user.email}
                </Typography>
              )}

              <Button
                id="user-button"
                aria-controls={open ? 'user-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
                sx={{
                  padding: 0,
                  minWidth: 'auto'
                }}
              >
                <Avatar
                  sx={{
                    bgcolor: '#667eea',
                    cursor: 'pointer',
                    width: isResponsiveMobile ? 28 : 32,
                    height: isResponsiveMobile ? 28 : 32,
                    fontSize: isResponsiveMobile ? '12px' : '14px'
                  }}
                >
                  {getInitials(user.email)}
                </Avatar>
              </Button>

              <Menu
                id="user-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
              >
                <MenuItem onClick={handleLogout} sx={{ color: '#d32f2f' }}>
                  <LogoutIcon sx={{ mr: 1, fontSize: '18px' }} />
                  Uitloggen
                </MenuItem>
              </Menu>
            </>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
}